import './Issue.scss';
import { Card } from 'antd';
import { CodeItem } from '@ui/general/CodeItem';
import { IssueHeader } from './IssueHeader';
import React from 'react';
export const Issue = ({ issue, hideActions, visibility }) => {
    const { code, id, range } = issue;
    return (React.createElement(Card, { className: 'issue', id: `issue-${id}`, title: React.createElement(IssueHeader, { hideActions: hideActions, issue: issue, visibility: visibility }), type: 'inner' },
        React.createElement(CodeItem, { code: code, sections: range })));
};
